<template>
	<v-dialog v-model="dialogCursoCertificado" max-width="800px" persistent>
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-card-text v-if="progress">
				<h2 class="text-center">Não saia desta página até o fim do envio</h2>
				<v-progress-linear
					color="light-blue"
					height="25"
					:value="uploadPercentage"
					rounded
					striped
					reactive
				>
					<template v-slot="{ value }">
						<strong>{{ Math.ceil(value) }}%</strong>
					</template>
				</v-progress-linear>
			</v-card-text>

			<v-card-text>
				<v-form ref="form">
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-file-input
									v-model="file"
									label="Selecione um arquivo"
									accept=".pdf"
									show-size
								></v-file-input>
							</v-col>
							<v-col cols="12">
								<v-switch
									v-model="editedItem.certificado_mostrar"
									color="indigo"
									label="Mostrar ao aluno"
								></v-switch>
							</v-col>
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="warning" icon @click="close()" title="Fechar formulário">
					<v-icon>fal fa-times</v-icon>
				</v-btn>
				<v-btn color="success" icon @click="save()" title="Salvar formulário">
					<v-icon>fal fa-save</v-icon>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
	inheritAttrs: false,
	props: {
		curso: null,
		typeForm: {
			default: 0,
		},
	},

	data() {
		return {
			server: 'user_curso',
			editedItem: {
				certificado_id: 0,
				user_curso_id: '',
				certificado: '',
				certificado_mostrar: 1,
			},
			file: undefined,
			progress: false,
			uploadPercentage: 0,
		}
	},
	computed: {
		...mapState(['user', 'rules', 'dialogCursoCertificado']),
		formTitle() {
			return this.typeForm === 0 ? 'Cadastrar' : 'Editar'
		},
	},
	created() {
		if (this.typeForm === 1) {
			this.editedItem = Object.assign({}, this.curso)
			this.editedItem.certificado_mostrar=(this.editedItem.certificado_mostrar==1)? true:false
		}
	},

	methods: {
		close() {
			this.$store.dispatch('dialogCursoCertificado', { value: false })
			setTimeout(() => {
				this.$emit('changeTypeForm', {
					typeForm: 0,
					hideForm: 'cursoCertificado',
				})
			}, 300)
		},
		save() {
			if (this.$refs.form.validate()) {
				if (this.editedItem.certificado == undefined) {
					this.$store.dispatch('alert', {
						alertMessage: 'Selecione um arquivo',
						alertType: 1,
					})
				} else {
					this.progress = true
					if (this.typeForm === 0) {
						let formData = new FormData()
						formData.append('menu', this.server)
						formData.append('function', 'insert_curso_certificado')
						formData.append('user_id', this.user.id)
						formData.append('user_curso_id', this.curso.user_curso_id)
						formData.append('file', this.file)
						formData.append('mostrar', this.editedItem.certificado_mostrar)
						let vd = this
						this.$axiosPost
							.post('functions.php', formData, {
								headers: { Authorization: this.user.token },
								onUploadProgress: function(progressEvent) {
									vd.uploadPercentage = parseInt(
										Math.round(
											(progressEvent.loaded / progressEvent.total) * 100
										)
									)
								}.bind(vd),
							})
							.then(function(response) {
								if (response.data.error === 0) {
									vd.$store.dispatch('alert', {
										alertMessage: response.data.alertMessage,
										alertType: 0,
									})
									vd.$store.dispatch('searchUserCursos', { value: true })
									vd.close()
								} else {
									vd.progress = false
									vd.$store.dispatch('errorServer', {
										data: response.data,
										destination: vd.$route.path,
									})
								}
							})
							.catch(function(response) {
								console.log('ERROR!! ' + response)
							})
					} else {
						let formData = new FormData()
						formData.append('menu', this.server)
						formData.append('function', 'update_curso_certificado')
						formData.append('user_id', this.user.id)
						formData.append('id', this.editedItem.certificado_id)
						formData.append('certificado', this.editedItem.certificado)
						formData.append('file', this.file)
						formData.append('mostrar', this.editedItem.certificado_mostrar)
						let vd = this
						this.$axiosPost
							.post('functions.php', formData, {
								headers: { Authorization: this.user.token },
								onUploadProgress: function(progressEvent) {
									vd.uploadPercentage = parseInt(
										Math.round(
											(progressEvent.loaded / progressEvent.total) * 100
										)
									)
								}.bind(vd),
							})
							.then(function(response) {
								if (response.data.error === 0) {
									vd.close()
									vd.$store.dispatch('alert', {
										alertMessage: response.data.alertMessage,
										alertType: 0,
									})
									vd.$store.dispatch('searchUserCursos', { value: true })
								} else {
									vd.$store.dispatch('errorServer', {
										data: response.data,
										destination: vd.$route.path,
									})
								}
							})
							.catch(function(response) {
								console.log('ERROR!! ' + response)
							})
					}
				}
			}
		},
	},
}
</script>
